import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="DXY Capital - Your trusted financial partner" 
          className="hero-image" 
        />
        <p className="eyebrow">Skighnet · Amplify Gen 2</p>
        <h1>Welcome to your new site.</h1>
        <p className="lede">
          This repository ships with a modern React + Vite front end, preconfigured for
          AWS Amplify hosting. Customize the components below or replace them with your
          own implementation.
        </p>
        <div className="cta-row">
          <a href="https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html" target="_blank">
            Amplify Docs
          </a>
          <a href="https://github.com/skighnet" target="_blank" className="secondary">
            Visit Skighnet
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Deploy quickly</h2>
          <p>
            Push to GitHub and Amplify Web Compute will build, deploy, and host the optimized assets
            automatically with every commit.
          </p>
        </article>
        <article>
          <h2>Customize freely</h2>
          <p>
            Tailor the layout, connect APIs, or drop in generated content. This starter keeps things
            lightweight so you can iterate rapidly.
          </p>
        </article>
        <article>
          <h2>Automate updates</h2>
          <p>
            Pair this repo with Skighnet automations to regenerate pages, thumbnails, and analytics on
            a schedule.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;